import React from 'react';
import ErrorBoundary from './ErrorBoundary';

const errorWrapper = (Component: any, errorComponent?: React.ReactElement) => {
  const Wrapper: React.FC<any> = props => {
    return (
      <ErrorBoundary errorComponent={errorComponent}>
        <Component {...props} />
      </ErrorBoundary>
    );
  };

  Wrapper.displayName = Component.displayName || Component.name || 'Component';

  return Wrapper;
};

export default errorWrapper;
